module.exports = __webpack_public_path__ + "3f1b304231ee462b2165e67f52a200c7.pdf";